import { BP, Borders, Colors, Mixins, Typography, mq, mqMax } from '~/styles';
import type { TStyleSheet, TStyles } from '~/types/emotion-styles';

const separator: TStyles = {
  borderTop: Borders.separator,
  paddingTop: 40,
};

const styles: TStyleSheet = {
  footerContainer: {
    paddingBottom: 20,
  },
  externalAndMainContainer: {
    ...separator,
    [mq(BP.Large)]: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: 60,
      paddingTop: 60,
    },
  },
  externalContainer: {
    [mqMax(BP.MediumMax)]: {
      marginBottom: 60,
    },
    [mq(BP.Large)]: {
      flex: 1,
      marginRight: 20,
    },
  },
  downloadAppContainer: {
    display: 'none',
    [mq(BP.Large)]: {
      display: 'block',
      marginBottom: 40,
    },
  },
  downloadAppLinkItem: {
    ':not(:last-of-type)': {
      marginBottom: 12,
    },
  },
  downloadAppLink: {
    display: 'inline-flex',
  },
  socialLink: {
    display: 'inline-block',
    ':not(:last-of-type)': {
      marginRight: 20,
    },
  },
  mainContainer: {
    [mqMax(BP.MediumMax)]: {
      marginBottom: 60,
    },
    [mq(BP.Medium)]: {
      alignContent: 'center',
      display: 'flex',
      justifyContent: 'space-between',
    },
    [mq(BP.Large)]: {
      flex: 3,
    },
  },
  mainTitleAndLinksContainer: {
    [mqMax(BP.SmallMax)]: {
      ':not(:last-of-type)': {
        marginBottom: 40,
      },
    },
    [mq(BP.Medium)]: {
      flex: 1,
      ':not(:last-of-type)': {
        marginRight: 20,
      },
    },
  },
  mainTitle: {
    ...Typography.titleSection,
    marginBottom: 25,
  },
  mainLink: {
    display: 'block',
    marginBottom: 8,
  },
  legalAndCopyrightContainer: {
    [mq(BP.Medium)]: {
      paddingBottom: 40,
    },
    [mq(BP.Large)]: {
      ...separator,
      alignContent: 'center',
      display: 'flex',
      justifyContent: 'space-between',
    },
  },
  legalContainer: {
    [mqMax(BP.MediumMax)]: {
      ...separator,
      paddingBottom: 40,
    },
  },
  legalLinkContainer: {
    [mqMax(BP.SmallMax)]: {
      ':not(:last-of-type)': {
        marginBottom: 20,
      },
    },
    [mq(BP.Medium)]: {
      display: 'inline-block',
      ':not(:last-of-type)': {
        marginRight: 40,
      },
    },
  },
  legalLink: {
    ...Mixins.accessibleMinButtonSize(),
    display: 'block',
  },
  copyright: {
    ...Typography.metadataSmall,
    alignItems: 'center',
    color: Colors.white60,
    display: 'flex',
    [mqMax(BP.MediumMax)]: {
      ...separator,
    },
    [mq(BP.Large)]: {
      order: -1,
    },
  },
};

export default styles;
